<div class="modal-compact__wrapper">
  <div class="modal-compact" (sdClickOutside)="onClickOutside()" [style.maxWidth]="options().maxWidth">
    @if (!options().hideCloseButton) {
      <button class="modal-compact__close" (click)="onClose()">
        <sd-icon type="cross" class="icon-size-s icon-size-md-m icon-size-lg-l"></sd-icon>
      </button>
    }
    @if (options().title) {
      <div class="modal-compact__header">
        <h3 class="modal-compact__title text-h6-s text-md-h4-s">{{ options().title }}</h3>
      </div>
    }

    <div class="modal-compact__body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
